var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"the-button large-round-button-green-filled"},[_vm._v("\n      "+_vm._s(_vm.buttonname)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }